import React from "react";

import {
  DefineWhoAmI,
  DistributionMain,
  ProfileTreeList,
} from "@app/components";
import { useReverseRoute, useWindowDimensions } from "@app/contexts";
import { FileExplorer } from "@app/pages";
import { selectCurrentProfTreeList, useAppSelector } from "@app/state";

import "./profile.scss";

export const Profile = () => {
  const { routeInit } = useReverseRoute("profile");
  const { drawerHeight } = useWindowDimensions();
  const theTreedata = useAppSelector(selectCurrentProfTreeList);

  const renderProfileContent = () => {
    switch (theTreedata?.ptlCfgPage) {
      case "whoami":
        return <DefineWhoAmI />;
      case "distribution":
        return <DistributionMain distro={theTreedata?.id} />;
      case "distro/files":
        return <FileExplorer roots={[`${theTreedata?.id}`]} />;
      default:
        return null;
    }
  };

  return (
    <div
      ref={routeInit}
      className="profile-page"
      style={{ "--drawerHeight": `${drawerHeight}px` } as React.CSSProperties}
    >
      <div className="profile-tree-list">
        <ProfileTreeList />
      </div>
      <div className="profile-content">{renderProfileContent()}</div>
    </div>
  );
};
